import profileimage from "../assets/png/langa.JPG";
import resume from "../assets/RESUME.pdf";

export const headerData = {
    name: 'Langa Hoohlo',
    title: "Hello! I am",
    desciption: "Welcome to my corner of the internet! I'm Langa Hoohlo, a dedicated programmer who thrives on solving problems and creating digital solutions. With a strong commitment to self-learning, I'm constantly on the lookout for the latest technologies to incorporate into my web and app development projects. Join me on this exciting journey as I explore new horizons in the world of software, and together, we'll shape the future of technology.",
    // desciption: "Hello! I am Langa Hoohlo, a professional and passionate programmer in my daily life. A quick learner with a self-learning attitude. I love to learn and explore new technologies and am Passionate about Problem Solving. ",
    image: profileimage,
    imagebw: '',
    resumePdf: resume
    // resumePdf: ''
}
